import {FunctionComponent, HTMLAttributes} from 'react';

type Props = HTMLAttributes<HTMLDivElement>;

const DialogContent: FunctionComponent<Props> = ({children, ...props}) => {
  return (
    <div className="w-full text-base text-charcoal" {...props}>
      {children}
    </div>
  );
};

export default DialogContent;
